import React, {useState} from 'react';
import {useAuthContext}  from '../../../hooks/useAuthContext'

import NSNForm from '../../Components/NSNForm'
import DocumentTable from '../../Components/Tables/DocumentTable'
import ItemTable from '../../Components/Tables/ItemTable'
import ReferenceTable from '../../Components/Tables/ReferenceTable'
import CharTable from '../../Components/Tables/CharTable'

import './nsn-search.css'

const NSNSearch = () => { 
  const [nsnData, setNsnData] = useState([]);
  const [itemData, setItemData] = useState([]);
  const[refData, setRefData] = useState([]);
  const[charData, setCharData] = useState([]);
  const {user} = useAuthContext()

  if(!user){
    window.location.href = "/"
  }

  return (
    
    user &&
    <div className="searchPage">
      <NSNForm setNsnData={setNsnData}  setItemData={setItemData} setRefData={setRefData} setCharData={setCharData} />

      <h3>
        NSN Details:
        <ItemTable itemData = {itemData?.data || []}/>
      </h3>
      <h3>
        Contract History
        <DocumentTable nsnData={nsnData?.data || []}/>
      </h3>
      
      <h3>
        Part Numbers By Approved Source
        <ReferenceTable refData={refData?.data || []}/>
      </h3>

      <h3>
        NSN Item Characteristics
        <CharTable charData={charData?.data || []}/>
      </h3>
    </div>
    
  )
         
  
}

export default NSNSearch;